import React from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";

import styles from "./feedHeader.module.css";

// 05:00-11:59 morning, 12:00-17:59 afternoon, 18:00-04:59 evening.
const greetingKey = hour => {
  if (hour >= 5 && hour < 12) return "dashboard_feed_greeting_morning";
  if (hour >= 12 && hour < 18) return "dashboard_feed_greeting_afternoon";
  return "dashboard_feed_greeting_evening";
};

/**
 * "Good morning|afternoon|evening, {name}" + "{N} new since {weekday}" (GROWTH-7129/7128) — the My Feed
 * page's title (its only <h1>) since GROWTH-7573. The greeting follows the member's local hour
 * (GROWTH-7861). On a member's first visit (lastSeenAt null) there is no "since" to report, so only the
 * greeting renders.
 *
 * @param {Object} props
 * @param {string} props.firstName
 * @param {string|null} props.lastSeenAt ISO-8601, FeedCardPresenter::time(); null = first visit
 * @param {number} props.newCount whole-feed count, independent of the type filter
 * @param {Date} [props.now] the moment the greeting is for, read in the browser's local time; tests pin it
 */
const FeedHeader = ({ firstName, lastSeenAt, newCount, now = new Date() }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <h1 className={styles.greeting}>{t(greetingKey(now.getHours()), { name: firstName })}</h1>
      {lastSeenAt ? (
        <p className={styles.newSince}>
          <strong className={styles.newCount}>{t("dashboard_feed_new_count", { count: newCount })}</strong>{" "}
          {t("dashboard_feed_since_weekday", { weekday: format(new Date(lastSeenAt), "EEEE") })}
        </p>
      ) : null}
    </div>
  );
};

export default FeedHeader;
